import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import _ from 'lodash';
import DomainDTO from '@/common/service/domain-dto';
import { getDataNoFilter, getDataRes, getDataFilter } from '@/api/common/useRequest';
import { MODULE, ODATA as COMM_ODATA } from '@/constant/common';
import { getSchemaDefaultObject as getSchemaDefaultObjectHandler, mergeDomainsInSchema as mergeDomainsInSchemaHandler } from '@/utils/common';
import storeType from '@/store/modules/common/store-type';
import store from '@/store/index';
import { toODataDate as apiToODataDate, odataDateToString as apiOdataDateToString } from './odata';
import { ElMessage, ElNotification } from 'element-plus/es';
// 标准获取 domainlist
export function getDomains(serviceId, entitySet) {
  return getDataNoFilter(serviceId, entitySet).then(({
    d
  }) => {
    return handleDomainsRes(d);
  });
}
export function getDomainsByFilter(serviceId, entitySet, filters) {
  const url = `${serviceId}/${entitySet}`;
  let params = '';
  filters.forEach((item, index) => {
    index < filters.length - 1 ? params += `Fieldname eq '${item}' or ` : params += `Fieldname eq '${item}'`;
  });
  return getDataFilter(url, params).then(({
    d
  }) => {
    return handleDomainsRes(d);
  });
}
const handleDomainsRes = d => {
  let resData = {};
  let domainList = d.results;
  if (!_.isEmpty(domainList)) {
    domainList = _.map(domainList, item => {
      const domainDTO = new DomainDTO(item.Code, item.Text);
      const enumObject = {
        Fieldname: item.Fieldname,
        ...domainDTO
      };
      return enumObject;
    });
    resData = _.groupBy(domainList, 'Fieldname');
  }
  return resData;
};
// 处理odata返回数据直接给前端调用
export function handlerOdataRes(serviceId, entitySet, param) {
  return getDataRes(serviceId, entitySet, param).then(({
    d
  }) => {
    if (d.results === undefined) {
      return d;
    }
    // 处理后端返回的空日期 日期为空时不展示，不要展示0000-00-00 zhongli 2022.05.06
    d.results.forEach(item => {
      Object.keys(item).forEach(key => {
        if (item[key] === '0000-00-00') {
          item[key] = '';
        }
      });
    });
    return d.results || [];
  });
}
export function toODataDate(val, format = 'YYYY-MM-DD') {
  return apiToODataDate(val, format);
}
// 处理 odata 返回消息事件
export function handleResMsg(message = [], operaction) {
  const messageEntity = {
    error: [],
    warning: [],
    status: true
  };
  message.forEach(item => {
    if (item.Type && item.Type === COMM_ODATA.SUCESS) {
      if (operaction !== 'S') {
        ElMessage.success(item.MessageText);
      }
    } else if (item.Type === COMM_ODATA.ERROR) {
      messageEntity.error.push(item.MessageText);
    } else if (item.Type === COMM_ODATA.WARNING) {
      messageEntity.warning.push(item.MessageText);
    }
  });
  if (messageEntity.error.length) {
    messageEntity.status = false;
    if (messageEntity.error === 1) {
      ElMessage.error(messageEntity.error[0]);
    } else {
      ElNotification.error({
        dangerouslyUseHTMLString: true,
        message: messageEntity.error.join('<br>')
      });
    }
  } else if (!messageEntity.warning) {
    if (messageEntity.warning === 1) {
      ElMessage.warning(messageEntity.error[0]);
    } else {
      ElNotification.warning({
        dangerouslyUseHTMLString: true,
        message: messageEntity.error.join('<br>')
      });
    }
  }
  return messageEntity.status;
}
export function handleResSubmitMsg(message = [], operaction) {
  const messageEntity = {
    error: [],
    warning: [],
    status: true
  };
  message.forEach(item => {
    if (item.Type === COMM_ODATA.SUCESS) {
      return false;
    } else if (item.Type === COMM_ODATA.ERROR) {
      messageEntity.error.push(item.MessageText);
    } else if (item.Type === COMM_ODATA.WARNING) {
      messageEntity.warning.push(item.MessageText);
    }
  });
  if (messageEntity.error.length) {
    message.status = false;
    if (messageEntity.error === 1) {
      ElMessage.error(messageEntity.error[0]);
    } else {
      ElNotification.error({
        dangerouslyUseHTMLString: true,
        message: messageEntity.error.join('<br>')
      });
    }
  } else if (!messageEntity.warning) {
    if (messageEntity.warning === 1) {
      ElMessage.warning(messageEntity.error[0]);
    } else {
      ElNotification.warning({
        dangerouslyUseHTMLString: true,
        message: messageEntity.error.join('<br>')
      });
    }
  }
  return messageEntity.status;
}
/**
 * 将odata返回的日期转换为字符串形式的JavaScript日期
 * @param {String} val 值,格式为/Date(1614556800000)/
 * @param {String} format 格式化
 * @returns String
 */
export function odataDateToString(val = '', format = 'YYYY-MM-DD') {
  return apiOdataDateToString(val, format);
}
/**
 * 取得指定service下的schema
 * @param {string} serviceId 服务ID
 * @param {string} entityId EntityID
 * @returns schema对象
 */
export async function getSchemaByEntityId(serviceId, entityId) {
  const ret = await store.dispatch(storeType[MODULE.COMMON].ACTION.FETCH_ENTITY, {
    serviceId,
    entityId
  });
  if (_.isEmpty(ret)) {
    return null;
  }
  return Array.isArray(entityId) ? ret : ret[0];
}
/**
 * 取得指定service下的schema数组
 * @param {string} serviceId 服务ID
 * @param {array} entityIdArray EntityID数组
 * @returns schema数组
 */
export function getSchemaByEntityIdArray(serviceId, entityIdArray) {
  // return this.$store.dispatch(storeType[MODULE.COMMON].ACTION.FETCH_ENTITY, {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return store.dispatch(storeType[MODULE.COMMON].ACTION.FETCH_ENTITY, {
    serviceId,
    entityId: entityIdArray
  });
}
/**
 * 取得指定Entity Schema
 * @param {string} id
 */
export async function initialSchema(id, schemaState, schemaValue) {
  const schema = await getSchemaByEntityId(id, '');
  Object.keys(schema).forEach(key => {
    // this.$set(schemaState, key, schema[key])
    schemaState[key] = schema[key];
  });
  const defaultValue = getSchemaDefaultObject(schema);
  Object.keys(defaultValue).forEach(key => {
    // this.$set(schemaValue, key, defaultValue[key])
    schemaValue[key] = defaultValue[key];
  });
}
/**
 * 根据schema取得初始化对象
 * @param {*} schema
 * @param {*} id
 */
export function getSchemaDefaultObject(schema) {
  return getSchemaDefaultObjectHandler(schema);
}
export function mergeDomainsInSchema(schema, domains, mapList) {
  return mergeDomainsInSchemaHandler(schema, domains, mapList);
}
/**
 * 修改schema中金额现实方式
 * @param {*} schema
 * @param {*} amountProps
 */
export function amountFormatInSchema(schema, amountProp) {
  amountFormatInSchema(schema, amountProp);
}
/**
 * @param {*} val
 * @param {*} config
 * @returns formatterVal
 */
export function priceFormatter(val, config) {
  priceFormatter(val, config);
}
/**
 * 根据form-schema初始化对象
 * @param formSchema
 * @param schema
 */
export function getSchemaDefaultObjectByFormSchema(formSchema, schema) {
  return getSchemaDefaultObjectByFormSchema(formSchema, schema);
}
export function copyObjectByFromSchema(formSchema, src, schema) {
  return copyObjectByFromSchema(formSchema, src, schema);
}
/**
 * 将OData的日期类型转换成控件的日期类型
 */
export function sapDateToJsDate(timeStamp) {
  return odataDateToString(timeStamp);
}
/**
 * 将控件的日期类型转换成OData的日期类型
 */
export function jsDateToSapDate(timeStamp) {
  return toODataDate(timeStamp);
}
/**
 * 将OData的时间类型转换成控件的时间类型
 */
// export function sapTimeToJsTime(timeStamp) {
//   return odataTimeToString(timeStamp)
// }
/**
 * 将控件的时间类型转换成OData的时间类型
 */
// export function jsTimeToSapTime(timeStamp) {
//   return toODataTime(timeStamp)
// }
/**
 * 前端生成UUID
 * @param prefix
 */
export function generateUuid(prefix) {
  const random = _.random(100000, 999999);
  return prefix ? `${prefix}${random}` : `${random}`;
}
/**
 * 显示消息
 * @param {Message} message
 */
export function showMessage(message, params, opts) {
  const MESSAGE_DURATION = 2000;
  if (_.isEmpty(message)) {
    return;
  }
  const msg = message;
  if (typeof msg === 'string') {
    // msg = new Message(message, params)
  }
  msg.duration = MESSAGE_DURATION;
  // this.$message(_.assign({}, msg, opts));
}
export function toArrayTree(arr, opt) {
  return toArrayTree(arr, opt);
}
export function toTreeArray(arr, opt) {
  return toTreeArray(arr, opt);
}
export function filterTree(arr, iterate, opt) {
  return filterTree(arr, iterate, opt);
}
export function searchTree(obj, iterate, options, context) {
  return searchTree(obj, iterate, options, context);
}
export function orderBy(collection, iteratees, orders) {
  return orderBy(collection, iteratees, orders);
}
/**
 * 生成odata的$filter查询
 * @param {Object} val
 * @param {Boolean} isDeleteItem 默认为false，如指定为true，将对拼接入filter的数据从val对象中删除
 *
 * @returns
 */
export function getFilterStringByObject(val = {}, isDeleteItem) {
  const ret = [];
  const deleteKeyList = [];
  Object.keys(val).forEach(key => {
    const value = val[key];
    if (key.indexOf('$') !== 0) {
      let filterValue = '';
      // 布尔值处理
      if (_.isBoolean(value)) {
        filterValue = `'${value ? 'X' : ''}'`;
        // 字符串处理
      } else if (_.isString(value) && !_.isEmpty(value)) {
        filterValue = `'${value}'`;
      }
      if (!_.isEmpty(filterValue)) {
        ret.push(`${key} eq ${filterValue}`);
      }
      if (isDeleteItem) {
        deleteKeyList.push(key);
      }
    }
  });
  const originVal = val;
  deleteKeyList.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(originVal, key)) {
      delete originVal[key];
    }
  });
  if (ret.length > 0) {
    return ret.join(' and ');
  }
  return '';
}
export function getFilterStringByObjectAndSchema(val = {}, schemaProperties = {}, isDeleteItem, eqFieldList) {
  if (_.isEmpty(schemaProperties)) {
    return getFilterStringByObject(val, isDeleteItem);
  }
  const ret = [];
  const deleteKeyList = [];
  Object.keys(val).forEach(key => {
    const value = val[key];
    if (key.indexOf('$') !== 0) {
      const schemaItem = schemaProperties[key];
      let filterValue = '';
      // 布尔值处理
      if (_.isBoolean(value)) {
        filterValue = `'${value ? 'X' : ''}'`;
        ret.push(`${key} eq ${filterValue}`);
        // 字符串处理
      } else if (_.isString(value) && !_.isEmpty(value)) {
        if (schemaItem) {
          if (schemaItem.oneOf && _.isArray(schemaItem.oneOf)) {
            ret.push(`${key} eq '${value}'`);
          } else if (schemaItem.type === 'date') {
            ret.push(`${key} eq datetime'${toODataDate(value)}'`);
          } else if (eqFieldList && _.isArray(eqFieldList) && eqFieldList.indexOf(key) >= 0) {
            ret.push(`${key} eq '${value}'`);
          } else {
            ret.push(`substringof('${value}',${key})`);
          }
        } else {
          ret.push(`${key} eq '${value}'`);
        }
      } else if (_.isNumber(value)) {
        ret.push(`${key} eq ${value}`);
      } else if (schemaItem && schemaItem.type === 'date' && Array.isArray(value) && value && value.length === 2) {
        let [start, end] = value;
        start = toODataDate(start);
        end = toODataDate(end);
        ret.push(`(${key} ge datetime'${start}' and ${key} le datetime'${end}')`);
      } else if (Array.isArray(value) && value && value.length === 2 && (!schemaItem || !(schemaItem.anyOf || schemaItem.oneOf))) {
        const [start, end] = value;
        ret.push(`(${key} ge '${start}' and ${key} le '${end}')`);
      } else if (Array.isArray(value) && schemaItem && (schemaItem.anyOf || schemaItem.oneOf) && !_.isEmpty(value)) {
        let conditionString = `${value.map(arrItemVal => `${key} eq '${arrItemVal}'`).join(' or ')}`;
        if (value.length > 1) {
          conditionString = `(${conditionString})`;
        }
        ret.push(conditionString);
      }
      if (isDeleteItem) {
        deleteKeyList.push(key);
      }
    }
  });
  const originVal = val;
  deleteKeyList.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(originVal, key)) {
      delete originVal[key];
    }
  });
  if (ret.length > 0) {
    return ret.join(' and ');
  }
  return '';
}